import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import BackButton from "../BackButton";
import CustomButton from "components/CustomButton";
import InputSelectFieldGrid from "components/common/InputSelectFieldGrid";
import { getGroupsService } from "services/client/groupService";
import { errorAlert } from "helpers/alerts";
import { getCommercesService } from "services/client/commerceService";
import InputChipFieldGrid from "components/common/InputChipFieldGrid";

const EmailReportForm = ({ title, goBack, defaultValues, submit }) => {
  const { control, handleSubmit, setValue } = useForm({ defaultValues });
  const [groups, setGroups] = useState([])
  const [commerces, setCommerces] = useState([])

  useEffect(() => {
    getGroupsService()
      .then((response) => setGroups(response))
      .catch((e) => errorAlert(e));
    getCommercesService(undefined, true)
      .then((response) => setCommerces(response))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = (data) => {
    submit(data);
  }

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" >
        <div>
          <BackButton name={title} click={goBack} />
        </div>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" mt={"40px"}>
        <Grid width={"70%"} container spacing={3}>
          <InputSelectFieldGrid
            label={"Grupo"}
            name={"group"}
            xs={6}
            control={control}
            data={groups}
            onSelect={() => setValue('hoster', null)}
          />
          <InputSelectFieldGrid
            label={"Comercio"}
            name={"hoster"}
            xs={6}
            control={control}
            data={commerces.map(c => ({ id: c._id, name: c.username }))}
            onSelect={() => setValue('group', null)}
          />
          <InputSelectFieldGrid
            label={"Rango"}
            name={"range"}
            required={"Debes seleccionar un rango"}
            xs={6}
            control={control}
            data={[
              { id: 'daily', name: "Diario" },
              { id: 'weekly', name: "Semanal" },
              { id: 'monthly', name: "Mensual" },
            ]}
          />
          <InputSelectFieldGrid
            label={"Tipo"}
            name={"type"}
            required={"Debes seleccionar un tipo"}
            xs={6}
            control={control}
            data={[
              { id: 'balance', name: "Saldos" },
              { id: 'movements', name: "Movimientos" },
            ]}
          />
          <InputChipFieldGrid
            xs={12}
            name={"emails"}
            control={control}
            label={"Correos electrónicos"}
          />
          <Grid container justifyContent="center" mt={5}>
            <CustomButton
              click={handleSubmit(handlerSubmit)}
              name={"Guardar"}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EmailReportForm;
